/**
 * @generated SignedSource<<cdab917bd734f28694035f38acdbd92e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSidebar_item$data = {
  readonly hasPrivateListing: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebarItemInfo_item" | "CheckoutSidebarPromotion_item" | "CheckoutTotals_item">;
  readonly " $fragmentType": "CheckoutSidebar_item";
};
export type CheckoutSidebar_item$key = {
  readonly " $data"?: CheckoutSidebar_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSidebar_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSidebar_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarItemInfo_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTotals_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarPromotion_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPrivateListing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "e056d8e2816d26813e5b013cdeef5c86";

export default node;
